import * as urls from "../../../api/schedulingPortal/url";
import client, { getHeader } from "../../../api/client";
import { interceptor, substituteEncrypted } from "../../../util/util";

export const cfstDashboardCount = async (reqBody) => interceptor(async () => client.post(urls.CFST_DASHBOARD_COUNT, await substituteEncrypted(reqBody), getHeader()));

export const cfstDashboardComparisonView = async (reqBody) => interceptor(async () => client.post(urls.CFST_DASHBOARD_TRENDS, await substituteEncrypted(reqBody), getHeader()));

export const cfstDashboardDeReCasesCount = async (reqBody) => interceptor(async () => client.post(urls.CFST_DERE_CASECOUNTS, await substituteEncrypted(reqBody), getHeader()));